import { getABTestValue } from './selectors';

export const isUATStand = () =>
  document.cookie.indexOf('25033DF0F2CA4154B4A00207AE34133D=true') !== -1;
export const getABTestValueByStand = (state) => {
  let abNewBasket = getABTestValue(state, 'abtest_new_basket');

  // временный аб тест для шопа, отдельно от битуси
  // если данный тест заведен (в селекторе не пустая строка), abNewBasket принимает его значение
  // если теста нет, abNewBasket = abtest_new_basket
  const abNewBasketShop = getABTestValue(state, 'abtest_new_basket_shop');
  if (abNewBasketShop) {
    // если abtest_new_basket_shop не равен пустой строке
    abNewBasket = abNewBasketShop;
  }

  if (!abNewBasket) {
    abNewBasket = '""';
  }

  return JSON.parse(abNewBasket);
};
